var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.5","fillRule":"evenodd","clipRule":"evenodd","d":"M11.4282 22.1667C17.7399 22.1667 22.8565 17.2045 22.8565 11.0833C22.8565 4.96218 17.7399 0 11.4282 0C5.1166 0 0 4.96218 0 11.0833C0 17.2045 5.1166 22.1667 11.4282 22.1667Z","fill":"black","key":0}),React.createElement("path",{"d":"M16.8783 6.44976C17.309 6.00227 18.0321 5.97808 18.4936 6.39574C18.955 6.8134 18.9799 7.51474 18.5493 7.96223L10.5495 16.2747C10.1317 16.7089 9.43522 16.7465 8.97028 16.36L4.97039 13.035C4.49118 12.6366 4.43568 11.937 4.84644 11.4722C5.25719 11.0074 5.97866 10.9536 6.45787 11.352L9.62601 13.9856L16.8783 6.44976Z","fill":"white","key":1})]);
}

Tick.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
